import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/scenes/HomePage.vue'; // 主页
import PrivacyPolicy from '@/scenes/PrivacyPolicy.vue'; // 隐私协议页面

const DEFAULT_TITLE = 'QuickMatrixTool - 快速启动 / 快速切换工具(Windows 桌面工具)';

const routes = [
  {
    path: '/',
    component: HomePage,
    meta: { title: DEFAULT_TITLE },
  },
  {
    path: '/privacy-policy',
    component: PrivacyPolicy,
    meta: { title: '隐私协议 - QuickMatrixTool' },
  },
  // 兜底:未匹配路径回到首页,避免 404 白屏
  { path: '/:pathMatch(.*)*', redirect: '/' },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.afterEach((to) => {
  const title = to.meta && to.meta.title;
  if (title) document.title = title;
});

export default router;
